import { Group } from "../../../dto/group"
import { Store } from "../../../dto/store/store"
import { User } from "../../../dto/user"
import httpClient from "../../../service/api"
import { findAllStores } from "../../home/filter/service"
import { findUsers } from "../../user/list/service"

export class GroupData {
  allStores?: Store[]
  allUsers?: User[]
  group: Group = {};
}

export const save = async (group:Group) : Promise<void> => {
  const resquest = {...group, stores: group.stores?.map(m => m.id)}
  if (group.id) {
    await httpClient.post('/api/group/update', resquest)
  } else {
    await httpClient.post('/api/group/create', resquest)
  }
}

export const findData = async (id:Number | undefined) : Promise<GroupData> => {
  const stores: Store[] = await findFullStores()
  const users: User[] = await findUsers()
  const group: Group = id ? (await httpClient.get('/api/group/' + id)).data : new Group

  return {
    group: group,
    allUsers: users,
    allStores : stores
  }
}

export const findFullStores = async (): Promise<Store[]> => {
    const response = await httpClient.get('/api/store/full')
    return response.data
}
